
import * as DrillThroughConstants from './DrillThroughConstants';
import AppService from 'Global/AppService';

const addDeviceToDTReducerState = (instanceId) => {
	return {
		type: DrillThroughConstants.DT_DEVICE_STATE_ADD,
		payload: instanceId
	}
};

const removeDeviceFromDTReducerState = (instanceId) => {
	return {
		type: DrillThroughConstants.DT_DEVICE_STATE_REMOVE,
		payload: instanceId
	}
};

const getFailedCalibData = (url,payload,deviceId) => {

	return (dispatch) => {
		dispatch({ type: DrillThroughConstants.DT_CALIB_DATA_FETCHING,payload:deviceId });

		function callback(success, err) {
			console.log({ success });
			if (success && success.result) {
				dispatch(getFailedCalibDataSuccess(success,deviceId));
			} else {
				dispatch(getFailedCalibDataFailure(deviceId));
			}
		}

		AppService.postData(payload, url, callback);
	}
}

const getFailedCalibDataSuccess = (successResponse,deviceId) => {
	return { type: DrillThroughConstants.DT_CALIB_DATA_FETCHED, payload:{newState: successResponse,deviceId:deviceId} };
}

const getFailedCalibDataFailure = (deviceId) => {
	return { type: DrillThroughConstants.DT_CALIB_DATA_FETCHED_FAILED,payload:deviceId };
}

const getFailedQCData = (url,payload,deviceId) => {

	return (dispatch) => {
		dispatch({ type: DrillThroughConstants.DT_QC_DATA_FETCHING,payload:deviceId });

		function callback(success, err) {
			console.log({ success });
			if (success && success.result) {
				dispatch(getFailedQCDataSuccess(success,deviceId));
			} else {
				dispatch(getFailedQCDataFailure(deviceId));
			}
		}

		AppService.postData(payload, url, callback);
	}
}

const getFailedQCDataSuccess = (successResponse,deviceId) => {
	return { type: DrillThroughConstants.DT_QC_DATA_FETCHED, payload:{newState: successResponse,deviceId:deviceId} };
}

const getFailedQCDataFailure = (deviceId) => {
	return { type: DrillThroughConstants.DT_QC_DATA_FETCHED_FAILED ,payload:deviceId };
}

export {
	getFailedCalibData,
    getFailedCalibDataSuccess,
    getFailedCalibDataFailure,
	getFailedQCData,
	getFailedQCDataSuccess,
	getFailedQCDataFailure,
	addDeviceToDTReducerState,
	removeDeviceFromDTReducerState
}